import { styled } from '@mui/material/styles'
import TableCell from '@mui/material/TableCell'

const LabelTableCell = styled(TableCell)(() => ({
  textAlign: 'right',
  fontWeight: 600,
  width: '20%'
}))

export default LabelTableCell
